import { render } from "./TableHead.vue?vue&type=template&id=676178a7&ts=true"
import script from "./TableHead.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableHead.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/table/TableHead.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "676178a7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('676178a7', __exports__)) {
    api.reload('676178a7', __exports__)
  }
  
  module.hot.accept("./TableHead.vue?vue&type=template&id=676178a7&ts=true", () => {
    api.rerender('676178a7', render)
  })

}


export default __exports__